import VueBaseController from '../../vue_base'

// eslint-disable-next-line import/prefer-default-export
export class IndexController extends VueBaseController {
  static get COMPONENT() { return () => import('@/vue/pages/users/pr/notifications/index.vue') }

  connect() {
    super.connect({})
  }
}
